import { render, staticRenderFns } from "./HubToRtmDetails.vue?vue&type=template&id=9650d5a8&scoped=true&"
import script from "./HubToRtmDetails.vue?vue&type=script&lang=js&"
export * from "./HubToRtmDetails.vue?vue&type=script&lang=js&"
import style0 from "./HubToRtmDetails.vue?vue&type=style&index=0&id=9650d5a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9650d5a8",
  null
  
)

export default component.exports